import { useState, useEffect} from 'react';
import { StyledEngineProvider } from '@mui/material/styles';
import {Routes, Route, useNavigate, useLocation, matchPath } from 'react-router-dom';
import AppBar from './components/AppBar';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import useGeolocationPermission from './hooks/useGeolocationPermission';
import Home from './routes/Home';
import JobAdvert from './routes/JobAdvert';
import JobApplication from './routes/JobApplication';
import ApplicationSuccess from "./routes/ApplicationSuccess";
import NewStarter from './routes/NewStarter';
import Error from './routes/ErrorPage';
import { ErrorPopupProvider } from "./components/ui/ErrorPopupContext";
import ErrorPopupDialog from "./components/ui/ErrorPopupDialog";
import InactivityHandler from './utils/InactivityHandler';
import useNavigationBlocker from './hooks/useNavigationBlocker';
function App() {
  const theme = createTheme({
    palette: {
      primary: {
        light:'#3b89bb',
        main: '#267cb4',
        dark:'#222C61'
      },
      secondary:{
        light:'#d95454',
        main:'#d54242',
        dark:'#bf3b3b',
      },
      error:{
        light:'#d95454',
        main:'#d54242',
        dark:'#bf3b3b',
      }
    },
  });

  
 

  const [displayInactivity, setDisplayInactivity] = useState(false);

  const navigate = useNavigate();
  useNavigationBlocker(
    ["/"], // Ignored static routes
    ["/job/:id"]      // Ignored dynamic routes
  );

const handleInactivity = () => {
    setDisplayInactivity(true);
    navigate('/');
  };



  return (

    // App.js
<StyledEngineProvider injectFirst>
    <ErrorPopupProvider>  {/* Then wrap with ErrorPopupProvider */}
      <InactivityHandler onTimeout={handleInactivity} />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <ThemeProvider theme={theme}>
          <AppBar />
          <Routes>
            <Route path="/" element={<Home/>} />
            <Route path="/job/:id" element={<JobAdvert />} />
            <Route path="/job/:id/apply" element={<JobApplication />} />
            <Route path="/application-success" element={<ApplicationSuccess />} />
            <Route path="/new-starter" element={<NewStarter />} />
            <Route path="*" element={<Error />} />
          </Routes>
          <ErrorPopupDialog />
        </ThemeProvider>
      </LocalizationProvider>
    </ErrorPopupProvider>
</StyledEngineProvider>


  );
}

export default App;
